import MainLayout from "@/components/layout/MainLayout";
import Seo from "@/components/base/Seo";
import { faqItems } from "@/mocks/faq";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import Ranking from "./components/Ranking";
import NewWorks from "./components/NewWorks";
import Completed from "./components/Completed";
import FreeZone from "./components/FreeZone";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Cta from "./components/Cta";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "歪歪漫画网 - 漫画分类大全 · 人气排行 · 热门榜单",
    url: "https://panelpal.github.io/",
    inLanguage: "zh-CN",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
];

export default function Home() {
  return (
    <MainLayout>
      <Seo
        title="歪歪漫画网 - 漫画分类大全 · 人气排行 · 热门榜单"
        description="歪歪漫画网分类大全覆盖恋爱、热血、悬疑、治愈等全题材，人气排行与热门榜单实时更新。新作推荐、完结作品、免费专区一键切换，快速找到你想看的那部漫画。"
        keywords="歪歪漫画网,漫画分类大全,人气排行,热门榜单,新作推荐,完结作品,免费专区"
        canonical="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <Categories />
      <Ranking />
      <NewWorks />
      <Completed />
      <FreeZone />
      <Features />
      <Testimonials />
      <Faq />
      <Cta />
    </MainLayout>
  );
}